import { useMemo } from 'react';

import { CustomBenchmarkSuccessResponse } from '@/api/rest/resources/types/benchmark';
import { useDashboardOrganizationSummary } from '@/hooks/useDashboardOrganizationSummary';
import { isNullish } from '@/utils/booleans';
import { squareMetersToHectares } from '@/utils/plot';

export const useScaledCustomBenchmark = (
  benchmark: CustomBenchmarkSuccessResponse | null | undefined,
  isTotal: boolean,
  overrideAreaSqm?: number,
) => {
  const { data } = useDashboardOrganizationSummary();
  const areaSqm = overrideAreaSqm !== undefined ? overrideAreaSqm : (data?.total_size ?? 0);
  const areaHa = squareMetersToHectares(areaSqm);

  return useMemo(() => {
    if (!benchmark) return null;
    if (!isTotal) return benchmark;

    return {
      ...benchmark,
      low_value: !isNullish(benchmark.low_value) ? benchmark.low_value * areaHa : undefined,
      moderate_value: !isNullish(benchmark.moderate_value) ? benchmark.moderate_value * areaHa : undefined,
      high_value: !isNullish(benchmark.high_value) ? benchmark.high_value * areaHa : undefined,
    };
  }, [benchmark, isTotal, areaHa]);
};
